export default __webpack_public_path__ + "static/media/evening-small-min.1571cd25.jpg";